<template>
  <div class="form-group" v-bind:class="{ error: error[0] }">
    <label for="amount">Сумма</label>
    <vue-numeric
      :currency="currencySign()"
      currency-symbol-position="suffix"
      type="text"
      separator=","
      class="form-control"
      v-model="localValue"
      :minus="false"
      :precision="2"
      id="amount"
      :disabled="disabled">
    </vue-numeric>

    <div class="error">{{ error[0] }}</div>
  </div>
</template>

<script>
import VueNumeric from 'vue-numeric'
import helpers from '@/helpers'

export default {
  name: 'amount-field',
  components: { VueNumeric },
  props: {
    value: [Number, String, Array],
    currency: [Number, String, Array],
    error: Array,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      localValue: 0.0
    }
  },
  watch: {
    value: function (val) {
      if (this.isArray(val)) {
        this.localValue = val[0]
      } else {
        this.localValue = val
      }
    },
    localValue: function (val) {
      this.updateValue(val)
    }
  },
  mounted () {
    if (this.isArray(this.value)) {
      this.localValue = this.value[0]
    } else {
      this.localValue = this.value
    }
  },
  methods: {
    isArray: helpers.isArray,
    currencySign: helpers.currencySign,
    updateValue (value) {
      if (this.isArray(value)) {
        this.$emit('input', value[0])
      } else {
        this.$emit('input', value)
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// Amount.vue?8da27e32